import React from 'react';
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

// Filter props to prevent styled-components v6 warnings
// This allows props like 'center', 'compact', etc. from DataTable to be filtered
const shouldForwardProp = (propName) => {
  // Allow all valid HTML attributes and data-* attributes
  return isPropValid(propName);
};

root.render(
  <StrictMode>
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <App />
    </StyleSheetManager>
  </StrictMode>
);
